export const TELESTRATION_TOOLTIP_CONTAINER = "#pixellotPlayer";
